<template>
  <div class="inner-box">
    <el-form size="mini" :model="form" ref="AgentZoneForm">
      <el-row>
        <el-col :span="10">
          <el-form-item label="AS지정점">
            <el-select v-model="form.areaAgent">
              <el-option value='' label="전체">==전체==</el-option>
              <el-option
                  v-for="item in combos['areaAgent']"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value">
              </el-option>
            </el-select>
            <el-select v-model="form.areaAgentDetail" v-if="form.areaAgent != ''">
              <el-option value='' label="선택">선택</el-option>
              <el-option
                  v-for="item in combos['areaAgentDetail']"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="AS기사">
            <el-select v-model="form.agerntUser">
              <el-option value='' label="선택">선택</el-option>
              <el-option
                  v-for="item in combos['agerntUser']"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";

export default {
  name: "AgentZoneInfo",
  props: ['custParam'],
  data() {
    return {
      form: {
        asAgentId: "",
        asAgentNm: "",
        companyId: "",
        dongNm: "",
        guNm: "",
        siNm: "",
        userId: "",
        userNm: "",
        areaAgent: "",
        areaAgentDetail: "",
        agentZoneStatus: "",
        agerntUser: "",
      },
      combos: {
        'areaAgent' : [],             //지역구분
        'areaAgentDetail' : [],             //지역구분
        'agerntUser' : [],        //AS기사
      },
      // eslint-disable-next-line vue/no-dupe-keys
    };
  },
  methods: {
    setAgnetZoneInfo() {
      Object.assign(this.form, this.groupDetail);
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/agentZoneMng/init`,{
        parentId: this.form.areaAgent,
        parentId2: this.form.areaAgentDetail
      })
          .then(response => {
            this.combos['areaAgent'] = response.data.areaAgent;            //지역구분
            this.combos['areaAgentDetail'] = response.data.areaAgentDetail;//지역구분상세
            this.combos['agerntUser'] = response.data.agerntUser;  //AS기사
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });
    },
  },
  beforeMount() {
    this.init();
  },
  watch: {
    custParam() {
      this.setAgnetZoneInfo();
    },
    'form.areaAgent'() {
      this.init();
    },
    'form.areaAgentDetail'() {
      this.init();
    },
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}

</style>